import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { fetchExternalUser, health, illness, medicine } from '@/api';
import { invoke } from 'wecom-sidebar-jssdk';
import { Tabs, message, Descriptions, Card } from 'ant-design-vue';
let ExternalUser = class ExternalUser extends Vue {
    constructor() {
        super(...arguments);
        this.externalUser = {};
        this.activeKey = '1';
        this.centered = true;
        this.healthData = {};
        this.illnessData = [];
        this.medicineData = {};
        this.size = 'small';
        this.genderSelect = [{
                label: '未知',
                value: 0
            }, {
                label: '男',
                value: 1
            },
            {
                label: '女',
                value: 2
            }
        ];
        this.smokeAnddrinking = [{
                label: '未知',
                value: 0
            }, {
                label: '从不',
                value: 1
            },
            {
                label: '偶尔',
                value: 2
            },
            {
                label: '经常',
                value: 3
            }
        ];
        this.laborSelecct = [{
                label: '未知',
                value: 0
            }, {
                label: '在家休息',
                value: 1
            },
            {
                label: '轻体力',
                value: 2
            },
            {
                label: '中体力',
                value: 3
            },
            {
                label: '重体力',
                value: 4
            }
        ];
        this.dietSelecct = [{
                label: '清淡',
                value: 1
            },
            {
                label: '偏油',
                value: 2
            },
            {
                label: '偏甜',
                value: 3
            },
            {
                label: '偏咸',
                value: 4
            },
            {
                label: '偏辣',
                value: 5
            }
        ];
    }
    async getExternalUserInfo() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.externalUser = await fetchExternalUser(res.userId);
        }
        catch (e) {
            message.error(e);
        }
    }
    async getHealth() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.healthData = await health(res.userId);
        }
        catch (e) {
            message.error(e);
        }
    }
    async getIllness() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.illnessData = await illness(res.userId);
        }
        catch (e) {
            message.error(e);
        }
    }
    async getMedicine() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.medicineData = await medicine(res.userId);
        }
        catch (e) {
            message.error(e);
        }
    }
    async mounted() {
        await this.getExternalUserInfo();
        await this.getHealth();
        await this.getIllness();
        await this.getMedicine();
    }
};
ExternalUser = __decorate([
    Component({
        name: 'ExternalUser',
        components: {
            'a-tabs': Tabs,
            'a-card': Card,
            'a-tab-pane': Tabs.TabPane,
            'a-descriptions': Descriptions,
            'a-descriptions-item': Descriptions.Item,
        }
    })
], ExternalUser);
export default ExternalUser;
